
import store from '../../store';
import Vue from 'vue';

const success = (data, resolve) => {
  const orderReceivedWidgetsData = data;
  store.dispatch('fetchOrderReceivedDataWidgets', orderReceivedWidgetsData);
  resolve();
};

const failed = (error, reject) => reject(error);

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('user-widgets/order-received')
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/widgets/fetchOrderReceivedWidgets.js